import Button from '@material-ui/core/Button';
import FunctionButton from 'shared/components/FunctionButton';
import IndeterminateCircularProgress from 'shared/components/IndeterminateCircularProgress';
import PropTypes from 'prop-types';
import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { TextField } from 'shared/reduxFormMaterialUi/TextField';
import { validateRequiredFields } from 'shared/utils/reduxFormHelpers';
import { withStyles } from '@material-ui/core/styles';

const requiredFields = [
	{ name: 'firstName', description: 'First name' },
	{ name: 'lastName', description: 'Last name' },
	{ name: 'email', description: 'Email' },
	{ name: 'password', description: 'Password' },
];

const styles = theme => ({
	button: {
		backgroundColor: theme.palette.primary.main,
		color: theme.palette.getContrastText(theme.palette.primary.main),
		'&:hover': {
			backgroundColor: theme.palette.primary.light,
		},
	},
	inputField: {
		padding: '8px 0px 15px',
	},
	loginContainer: {
		/* Center this */
		margin: '0 auto',
		width: 350,
		padding: '2em',
		fontSize: '12pt',
		fontFamily: theme.typography.fontFamily,

		'@media only screen and (max-height: 600px) and (orientation: landscape)': {
			height: '70vh',
			overflow: 'auto',
		},
		'@media only screen and (max-width: 600px) and (orientation: portrait)': {
			width: '70vw',
		},
	},
	loginHeader: {
		/* Center this */
		textAlign: 'center',
		fontSize: '14pt',
		padding: 8,
		fontWeight: 'bold',
	},
	loginInputArea: {
		paddingTop: 12,
		paddingBottom: 24,
	},
	loginSignUp: {
		textAlign: 'center',
		padding: 4,
	},
	submitContainer: {
		position: 'relative',
		textAlign: 'center',
		paddingBottom: 8,
	},
});

/**
 * Allow the user to register a new user or switch to the login form if they already have an account.
 * @param {React props} props
 */
const RegistrationForm = props => {
	const { handleSubmit, isRegistering, register, switchModal, cancelToken, classes } = props;

	return (
		<div>
			<div className={classes.loginContainer}>
				<div className={classes.loginHeader}>Sign Up Here</div>
				<form
					onSubmit={handleSubmit(values =>
						// Redux thunk to make a register post request.
						register(cancelToken, values.email, values.password, values.firstName, values.lastName),
					)}
				>
					<div className={classes.loginInputArea}>
						<Field
							name="firstName"
							className={classes.inputField}
							label={<div style={{ marginTop: 10 }}>First Name</div>}
							component={TextField}
						/>
						<Field
							name="lastName"
							className={classes.inputField}
							label={<div style={{ marginTop: 10 }}>Last Name</div>}
							component={TextField}
						/>
						<Field
							name="email"
							className={classes.inputField}
							label={<div style={{ marginTop: 10 }}>Email</div>}
							component={TextField}
						/>
						<Field
							name="password"
							type="password"
							className={classes.inputField}
							label={<div style={{ marginTop: 10 }}>Password</div>}
							component={TextField}
						/>
					</div>
					<div className={classes.submitContainer}>
						<Button type="submit" className={classes.button} disabled={isRegistering} >
							Sign Up
						</Button>
						{isRegistering ? <IndeterminateCircularProgress /> : null}
					</div>
				</form>
				<div className={classes.loginSignUp}>
					Already have an account?
					<FunctionButton label="Log in" onClickFunction={switchModal} />
				</div>
			</div>
		</div>
	);
};

RegistrationForm.propTypes = {
	cancelToken: PropTypes.objectOf(PropTypes.any).isRequired,
	classes: PropTypes.shape({
		button: PropTypes.string,
		inputField: PropTypes.string,
		loginContainer: PropTypes.string,
		loginHeader: PropTypes.string,
		loginInputArea: PropTypes.string,
		loginSignUp: PropTypes.string,
		submitContainer: PropTypes.string,
	}).isRequired,
	handleSubmit: PropTypes.func.isRequired,
	isRegistering: PropTypes.bool.isRequired,
	register: PropTypes.func.isRequired,
	switchModal: PropTypes.func.isRequired,
};

// Testing
export { RegistrationForm as RegistrationFormClass };

export default reduxForm({
	form: 'RegistrationForm',
	validate: validateRequiredFields(requiredFields),
})(withStyles(styles, { name: 'RegistrationForm' })(RegistrationForm));
